import {
  AssignedTagToSimDTO,
  FetchAssignedTagToSimsFilter,
} from '../../../tags/models/tagsApi.types';
import { createAsignTagApi, createTagApiService } from 'tags/utils/createTagApiService';
import { envVariables } from 'src/common/utils/envVariables';

const API_PATH = envVariables.VITE_SIM_INVENTORY_SIMS_PROFILE_API;
const { fetchTags, fetchTag, createTag } = createTagApiService({
  baseApiPath: API_PATH,
});

export const fetchSimTags = fetchTags;
export const fetchSimTag = fetchTag;
export const createSimTag = createTag;

const { fetchAssignedTagsToCards, fetchAssignedTagsToCard, assignTagsToCard } = createAsignTagApi<
  FetchAssignedTagToSimsFilter,
  AssignedTagToSimDTO[]
>({
  baseApiPath: API_PATH,
  cardIdName: 'iccid',
  cardArrayIdsName: 'iccids',
});

export const assignTagsToSim = assignTagsToCard;

export const fetchAssignedTagToSim = fetchAssignedTagsToCard;

export const fetchAssignedTagToSims = fetchAssignedTagsToCards;
